import React from "react";
const Q2 = () => {
  return (
    <div style={{ backgroundColor: "#Dbe6ea" }}>
      <div className="ans-bank">
        <div className="qta">What are Limitations of Liability?</div>
        <p>
          Your entry into this Giveaway constitutes Your agreement to release
          and hold harmless the Sponsor and its subsidiaries, representatives,
          affiliates, partners, advertising and promotion agencies, successors,
          agents, assigns, directors, employees, and officers against and from
          any and all claims, liability, illness, injury, death, litigation,
          loss, or damages that may occur, directly or indirectly from
          participation in the Giveaway and/or the 1) Winner accepting,
          possessing, using, or misusing of any awarded prize or any portion
          thereof; 2) any type of technical failure; 3) the unavailability or
          inaccessibility of any transmissions, phone, or Internet service; 4)
          unauthorized intervention in any part of the entry process or the
          Promotion; 5)electronic error or human error in the Promotion
          administration or the processing of entries.
        </p>
      </div>
    </div>
  );
};

export default Q2;
